import React from "react";
import { Box, Checkbox, Typography } from "@mui/material";

const backorderColor = "#a66a00";
const backorderBorder = "#f0b429";
const backorderBackground = "#fff8df";

export const BackorderControl = ({
  checked,
  disabled = false,
  label,
  onChange,
  sx,
}) => (
  <Box
    component="label"
    sx={{
      alignItems: "center",
      backgroundColor: backorderBackground,
      border: `1px solid ${backorderBorder}`,
      borderRadius: "8px",
      boxSizing: "border-box",
      cursor: disabled ? "default" : "pointer",
      display: "flex",
      justifyContent: "center",
      minHeight: 56,
      px: 1.5,
      width: "100%",
      ...sx,
    }}
  >
    <Checkbox
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      sx={{
        color: backorderColor,
        "&.Mui-checked": {
          color: backorderColor,
        },
        "&.Mui-disabled": {
          color: backorderColor,
        },
      }}
    />
    <Typography
      component="span"
      sx={{
        color: backorderColor,
        fontWeight: 600,
        lineHeight: 1.2,
        textAlign: "center",
        textTransform: "uppercase",
      }}
    >
      {label}
    </Typography>
  </Box>
);

export const BackorderState = ({ label, sx }) => (
  <Typography
    component="span"
    sx={{
      color: backorderColor,
      fontWeight: 700,
      lineHeight: 1.2,
      textTransform: "uppercase",
      whiteSpace: "nowrap",
      ...sx,
    }}
  >
    {label}
  </Typography>
);

export const MaterialOrderHeader = ({
  backorderLabel,
  showBackorder,
  title,
  sx,
}) => (
  <Box
    sx={{
      alignItems: "center",
      border: "1px solid rgba(0, 0, 0, 0.23)",
      borderRadius: "4px",
      boxSizing: "border-box",
      display: "grid",
      gap: 1,
      gridTemplateColumns: { xs: "1fr", sm: "1fr auto 1fr" },
      minHeight: 56,
      px: 2,
      py: 1,
      width: "100%",
      ...sx,
    }}
  >
    {showBackorder && (
      <BackorderState
        label={backorderLabel}
        sx={{
          gridColumn: { xs: 1, sm: 1 },
          gridRow: 1,
          justifySelf: "start",
        }}
      />
    )}
    <Typography
      component="span"
      sx={{
        gridColumn: { xs: 1, sm: 2 },
        gridRow: { xs: showBackorder ? 2 : 1, sm: 1 },
        textAlign: "center",
      }}
    >
      {title}
    </Typography>
  </Box>
);
